import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { map } from "rxjs";
import { Bank } from "../../model/domain/Bank";
import { DomainService } from "../../services/domain.service";
import { SnackbarService } from "../../services/snackbar.service";
import { ValidatorService } from "../../services/validator.service";

@Component({
  selector: "bank-register",
  templateUrl: "./bank-register.component.html",
  styleUrls: ["./bank-register.component.css"],
})
export class BankRegisterComponent implements OnInit {
  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  isEditing = false;
  canValidate = false;
  model: Bank;
  name: string = null;

  constructor(
    private router: Router,
    public validator: ValidatorService,
    private route: ActivatedRoute,
    private location: Location,
    private snackBarService: SnackbarService,
    private domainService: DomainService
  ) {}

  ngOnInit() {
    this.getBank();
  }

  // canNewCreateBank() {
  //   const roles = [Router.canNewCreateBank];
  //   return this.authService.hasRoles(roles);
  // }

  getBank() {
    this.model = new Bank();
    const id = +this.route.snapshot.paramMap.get("id");
    this.model.id = id;

    if (id) {
      this.domainService.GetBank(id).subscribe({
        next: (q) => {
          Object.assign(this.model, q);

          this.isEditing = true;
          this.canValidate = true;
        },
        error: () => this.router.navigate(["/bank-register"]),
      });
    }
  }

  submit() {
    const editing = this.isEditing;
    this.register()
      .pipe(
        map((model: Bank) => {
          if (!editing) {
            this.model.id = model.id;
            this.isEditing = true;
            const url = this.router.createUrlTree([this.model.id], {
              relativeTo: this.route,
            });
            this.location.go(url.toString());
          }
          return this.model;
        })
      )
      .subscribe({
        next: (result: Bank) => {
          const msg = editing ? "Banco alterado." : "Banco cadastrado.";

          this.snackBarService.open(msg, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        },

        error: (result) => {
          let err = result;
          if (result.status === 409) {
            err = "Banco já cadastrado!";
          } else if (result.message) {
            err = result.message;
          }

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        },
      });
  }
  register() {
    const editing = this.isEditing;
    Object.values(this.frm.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });
    this.canValidate = true;
    const data = Object.assign({}, this.model);

    data.code = this.validator.sanitize(data.code);

    const method = editing
      ? this.domainService.UpdateBank(this.model.id, data)
      : this.domainService.RegisterBank(data);

    location.reload;

    return method;
  }
}
